import * as React from "react";
const SvgFiRrCowbellCirclePlus = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cowbell-circle-plus_svg__a)">
      <path
        fill="#062147"
        d="M9.895 21.667A2 2 0 0 1 9 20v-1a1 1 0 0 0-1-1H4.001a1.998 1.998 0 0 1-1.97-2.352l1.282-7.176a2.996 2.996 0 0 1 2.953-2.473h9.467a3 3 0 0 1 2.905 2.249 1.001 1.001 0 0 0 1.937-.498A4.996 4.996 0 0 0 15.828 4 3.004 3.004 0 0 0 13-.001H9A3.004 3.004 0 0 0 6.172 4a4.994 4.994 0 0 0-4.828 4.12l-1.28 7.177a4 4 0 0 0 .87 3.271A3.99 3.99 0 0 0 4.001 20h3c0 1.344.667 2.589 1.787 3.333a1 1 0 1 0 1.106-1.666zM9 2h4a1.001 1.001 0 0 1 0 2H9a1.001 1.001 0 0 1 0-2m8 8c-3.86 0-7 3.141-7 7s3.14 7 7 7 7-3.141 7-7-3.14-7-7-7m0 12c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5m3-5a1 1 0 0 1-1 1h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1a1 1 0 1 1 2 0v1h1a1 1 0 0 1 1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cowbell-circle-plus_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCowbellCirclePlus;
